import { WALLET } from "@zenith/data/constants";
import { ValidationResult } from "@zenith/pages/SendMoneyPage/types";

export const validateWalletAccountFormat = (
  accountNumber: string
): ValidationResult<void> => {
  if (!accountNumber) {
    return {
      isValid: false,
      error: "Account number is required",
    };
  }

  if (accountNumber.length !== WALLET.ACCOUNT_LENGTH) {
    return {
      isValid: false,
      error: "Account number must be 10 digits",
    };
  }

  return {
    isValid: true,
  };
};
